// @ts-ignore
import styles from "./Language.module.scss";
import { Radio } from 'antd';
import { useDispatch, useSelector } from "react-redux";
import { changeLocale, selectIntl } from "../../../../redux/intl/intlSlice";
import { globalConfig, LocaleKey } from "../../../../config/config";
import { useTranslation } from "react-i18next";

const LANGUAGE_LIST = [
    {
        value: "zh-cn",
        text: "简体中文",
    },
    {
        value: "zh-tw",
        text: "繁體中文",
    },
    {
        value: "ja",
        text: "日本語",
    },
    {
        value: "en",
        text: "English",
    },
    {
        value: "el",
        text: "Ελληνικά",
    },
    {
        value: "hu",
        text: "Magyar",
    },
    {
        value: "ko",
        text: "한국어",
    },
    {
        value: "tr",
        text: "Türkçe",
    },
    {
        value: "pt",
        text: "Português",
    },
    {
        value: "fr",
        text: "Français",
    },
    {
        value: "es-419",
        text: "Español Latinoamericano",
    }
]

const style: React.CSSProperties = {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gap: '36px',
    width: '100%',
};


export const Language = () => {
    const { locale } = useSelector(selectIntl)
    const dispatch = useDispatch()
    const { i18n } = useTranslation();
    const onChangeLanguage = (value: string) => {
        // 保持用户选择的语言值，只在i18n切换时做语言映射
        // 简体中文和繁體中文都使用 zh-CN，其他语言都使用 en
        let i18nLocal = (value === "zh-cn" || value === "zh-tw") ? "zh-CN" : "en";
        dispatch(changeLocale(value))  // 保持用户选择的值
        globalConfig.setItem(LocaleKey, value)
        i18n.changeLanguage(i18nLocal);  // 只在i18n切换时做映射
    }


    return (
        <div className={styles.languageSetting} >
            <div className={styles.languageSettingContent}>
                <Radio.Group
                    onChange={(e) => onChangeLanguage(e.target.value)}
                    value={locale === "zh-CN" ? "zh-cn" : locale}
                    style={style}
                    options={
                        LANGUAGE_LIST.map((item) => {
                            return {
                                value: item.value,
                                label: (
                                    <div className={styles.languageItemText}>{item.text}</div>
                                ),
                                // 最后一个语言, 单独占两列
                                style: { gridColumn: item.value === "es-419" ? ' 3 / 5' : "0" },
                            }
                        })
                    }
                />
            </div>
        </div>
    );
};
